<mat-form-field class="no-label lead-status">
    <mat-select disableOptionCentering [value]="value" [disabled]="saving" (selectionChange)="change($event.value)">
        <mat-option *ngFor="let s of options" [value]="s">{{ s }}</mat-option>
    </mat-select>
</mat-form-field>
